import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  standalone: false,
  name: 'userName'
})
export class UserNamePipe implements PipeTransform {
  transform(user: any, defaultValue: string = '----'): string {
    if (!user) {
      return defaultValue;
    }

    const firstName = user.firstName;
    const lastName = user.lastName;
    const fullName = user.fullName;
    const businessName = user.businessName;

    return !!fullName ? fullName :
      (firstName && lastName ? `${firstName} ${lastName}` : (businessName || defaultValue));
  }
}
